import { PopperContent } from '@/components/poppers/PopperContent';

export function ResiduaryContextualHelp() {
  return (
    <PopperContent
      sx={{
        maxWidth: '250px',
      }}
      body="All taxes paid by this entity will come out of the residuary's portion. Turn this toggle off to individually specify which recipients' portions will be net of taxes."
    />
  );
}
